export default "__VITE_ASSET__BMqxMDyy__"